export default {
  beds: []
}
